"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TableSelectionCell", {
    enumerable: true,
    get: function() {
        return TableSelectionCell;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTableSelectionCell = require("./useTableSelectionCell");
const _renderTableSelectionCell = require("./renderTableSelectionCell");
const _useTableSelectionCellStylesstyles = require("./useTableSelectionCellStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const TableSelectionCell = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTableSelectionCell.useTableSelectionCell_unstable)(props, ref);
    (0, _useTableSelectionCellStylesstyles.useTableSelectionCellStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTableSelectionCellStyles_unstable')(state);
    return (0, _renderTableSelectionCell.renderTableSelectionCell_unstable)(state);
});
TableSelectionCell.displayName = 'TableSelectionCell';
